/* SPECULUM — Gate · Maxed Design · Symmetrical · Mobile-first
   Ordo Semeion · MMXXVI · Field Instrument №01 · Signal key: 999 */

const LORE_CHAPTERS = [
  { phase:"origin", lines:[
    {t:0,   text:"FIELD INSTRUMENT №01 · INITIALIZING",mono:true,dim:true},
    {t:600, text:"EXAMINING APPARATUS · CALIBRATING",mono:true,dim:true},
    {t:1200,text:"CHARTER §§I–VI · LOADED",mono:true,dim:true},
    {t:2000,text:"In 1947, a small assembly of scholars convened in a room that no official record names.",serif:true},
    {t:3200,text:"They shared one conviction: deployed language had begun to move faster than human examination could follow.",serif:true},
    {t:4600,text:"They called what was happening the Acceleration.",serif:true,gold:true},
    {t:5600,text:"They did not found an institution. They resumed one.",serif:true,dim:true},
  ]},
  { phase:"order", lines:[
    {t:0,   text:"THE ORDO SEMEION",mono:true,gold:true},
    {t:700, text:"The Order of the Sign. A discipline older than its name.",serif:true},
    {t:1800,text:"It passed through the Alexandrian grammarians. Through medieval scriptoria. Through the seventeenth-century tradition of ars critica.",serif:true,dim:true},
    {t:3400,text:"The Order does not intervene. It does not publish verdicts. It does not name deployers.",serif:true},
    {t:4600,text:"It examines. And releases.",serif:true,gold:true},
    {t:5400,text:"This is not a privacy policy. It is a philosophical commitment.",serif:true,dim:true},
  ]},
  { phase:"charter", lines:[
    {t:0,   text:"THE CHARTER · §§ I THROUGH VI",mono:true,gold:true},
    {t:800, text:"Six principles. One circuit. A complete account of how a text works.",serif:true,dim:true},
    {t:1800,text:"§I · SIGN FUNCTION · What signs are deployed, at what register",mono:true},
    {t:2700,text:"§II · DENOTATION / CONNOTATION · The gap between stated and implied",mono:true},
    {t:3600,text:"§III · MYTH & IDEOLOGY · What is naturalized. What is presented as inevitable.",mono:true},
    {t:4500,text:"§IV · CODES & CONVENTIONS · Which cultural grammar is engaged",mono:true},
    {t:5400,text:"§V · ADDRESSIVITY · Who is constructed as the reader.",mono:true},
    {t:6300,text:"§VI · DRIFT QUOTIENT · How far deployment diverges from stated purpose.",mono:true,gold:true},
  ]},
  { phase:"compiler", lines:[
    {t:0,   text:"THE COMPILER",mono:true,gold:true},
    {t:800, text:"Order records name the Charter's author by a single designation: the Compiler.",serif:true},
    {t:2000,text:"No name is recorded. The designation is functional, not honorific.",serif:true,dim:true},
    {t:3200,text:"The Compiler is not a person. It is a function: the node that translates raw signal into executable infrastructure.",serif:true},
    {t:4800,text:"The processing node that makes signal operational.",serif:true,gold:true},
    {t:5800,text:"The Charter was written in eleven days, in 1962. It has never been revised.",serif:true,dim:true},
  ]},
  { phase:"instrument", lines:[
    {t:0,   text:"FIELD INSTRUMENT №01 · THE BENCH",mono:true,gold:true},
    {t:800, text:"SPECVLVM · Auditus. The first instrument. The founding examination.",serif:true},
    {t:2000,text:"Place a specimen on the bench — advertisement, address, manifesto, packaging.",serif:true,dim:true},
    {t:3200,text:"The instrument disassembles its symbolic apparatus against the six principles.",serif:true},
    {t:4400,text:"The findings are yours.",serif:true,gold:true},
    {t:5200,text:"No magic; only mechanism, made plain.",serif:true,gold:true},
  ]}
];

const LORE_STREAM = LORE_CHAPTERS.flatMap((ch,ci) => [
  {text:"· · ·",mono:true,dim:true,chapter:ci},
  ...ch.lines.map(l=>({...l,chapter:ci}))
]);

/* ── Sound Engine ── */
function createSound() {
  let ctx = null;
  function get() {
    if (!ctx) ctx = new (window.AudioContext||window.webkitAudioContext)();
    return ctx;
  }
  return {
    play(type) {
      try {
        const c = get();
        const master = c.createGain();
        master.gain.setValueAtTime(0.16, c.currentTime);
        master.connect(c.destination);
        if (type === "keypress") {
          const o=c.createOscillator(), g=c.createGain();
          o.connect(g); g.connect(master);
          o.frequency.setValueAtTime(300, c.currentTime);
          o.frequency.exponentialRampToValueAtTime(160, c.currentTime+0.09);
          g.gain.setValueAtTime(0.5, c.currentTime);
          g.gain.exponentialRampToValueAtTime(0.001, c.currentTime+0.12);
          o.start(); o.stop(c.currentTime+0.12);
        } else if (type === "error") {
          [0,0.18].forEach((d,i) => {
            const o=c.createOscillator(), g=c.createGain();
            o.type="sawtooth"; o.connect(g); g.connect(master);
            o.frequency.setValueAtTime(200-i*55, c.currentTime+d);
            g.gain.setValueAtTime(0.45, c.currentTime+d);
            g.gain.exponentialRampToValueAtTime(0.001, c.currentTime+d+0.28);
            o.start(c.currentTime+d); o.stop(c.currentTime+d+0.28);
          });
        } else if (type === "unlock") {
          [220,330,440,660].forEach((freq,i) => {
            const o=c.createOscillator(), g=c.createGain();
            o.type="sine"; o.connect(g); g.connect(master);
            o.frequency.setValueAtTime(freq, c.currentTime+i*0.09);
            g.gain.setValueAtTime(0, c.currentTime+i*0.09);
            g.gain.linearRampToValueAtTime(0.38, c.currentTime+i*0.09+0.15);
            g.gain.exponentialRampToValueAtTime(0.001, c.currentTime+i*0.09+2.2);
            o.start(c.currentTime+i*0.09); o.stop(c.currentTime+i*0.09+2.2);
          });
        } else if (type === "boot") {
          const o=c.createOscillator(), g=c.createGain();
          o.type="sine"; o.connect(g); g.connect(master);
          o.frequency.setValueAtTime(55, c.currentTime);
          o.frequency.exponentialRampToValueAtTime(110, c.currentTime+0.9);
          g.gain.setValueAtTime(0, c.currentTime);
          g.gain.linearRampToValueAtTime(0.35, c.currentTime+0.3);
          g.gain.exponentialRampToValueAtTime(0.001, c.currentTime+1.4);
          o.start(); o.stop(c.currentTime+1.4);
        }
      } catch(e) {}
    }
  };
}

const sound = createSound();

function GateScreen({ onUnlock }) {
  const [phase, setPhase] = React.useState("void");
  const [loreChapter, setLoreChapter] = React.useState(0);
  const [showChapter, setShowChapter] = React.useState(false);
  const [inputVal, setInputVal] = React.useState("");
  const [attempts, setAttempts] = React.useState(0);
  const [errorMsg, setErrorMsg] = React.useState("");
  const [glitchActive, setGlitchActive] = React.useState(false);
  const [dissolving, setDissolving] = React.useState(false);
  const [skipLore, setSkipLore] = React.useState(false);
  const [keyholeState, setKeyholeState] = React.useState("idle");
  const [soundOn, setSoundOn] = React.useState(true);
  const inputRef = React.useRef(null);
  const chapterTimers = React.useRef([]);
  const soundRef = React.useRef(soundOn);
  React.useEffect(() => { soundRef.current = soundOn; }, [soundOn]);

  function play(type) { if (soundRef.current) sound.play(type); }

  React.useEffect(() => {
    const t0 = setTimeout(() => { setPhase("sigil"); play("boot"); }, 400);
    const t1 = setTimeout(() => { setPhase("lore"); setShowChapter(true); }, 2200);
    chapterTimers.current = [
      setTimeout(() => { setLoreChapter(1); setShowChapter(false); setTimeout(()=>setShowChapter(true),500); }, 10000),
      setTimeout(() => { setLoreChapter(2); setShowChapter(false); setTimeout(()=>setShowChapter(true),500); }, 19000),
      setTimeout(() => { setLoreChapter(3); setShowChapter(false); setTimeout(()=>setShowChapter(true),500); }, 28000),
      setTimeout(() => { setLoreChapter(4); setShowChapter(false); setTimeout(()=>setShowChapter(true),500); }, 37000),
      setTimeout(() => setPhase("challenge"), 45000),
    ];
    return () => [t0,t1,...chapterTimers.current].forEach(clearTimeout);
  }, []);

  React.useEffect(() => {
    if (skipLore) { chapterTimers.current.forEach(clearTimeout); setPhase("challenge"); }
  }, [skipLore]);

  React.useEffect(() => {
    if (phase === "challenge" && inputRef.current) setTimeout(()=>inputRef.current?.focus(),600);
  }, [phase]);

  function triggerGlitch() {
    setGlitchActive(true); setKeyholeState("error"); play("error");
    setTimeout(()=>{ setGlitchActive(false); setKeyholeState("idle"); }, 900);
  }

  function handleInputChange(e) {
    setInputVal(e.target.value);
    setKeyholeState(e.target.value.length > 0 ? "active" : "idle");
    if (e.target.value.length > inputVal.length) play("keypress");
  }

  function handleSubmit() {
    if (inputVal.trim() === "999") {
      setKeyholeState("unlocking"); setPhase("solving");
      setTimeout(()=>{ setKeyholeState("open"); setPhase("granted"); play("unlock"); }, 800);
      setTimeout(()=>{ setDissolving(true); setTimeout(()=>onUnlock(), 900); }, 3800);
    } else {
      const next = attempts + 1; setAttempts(next); triggerGlitch(); setInputVal("");
      if (next >= 3) setErrorMsg("SIGNAL CORRUPTED · OPERATOR IDENTITY UNVERIFIED · STAND DOWN");
      else if (next === 2) setErrorMsg(`ACCESS DENIED · ${3-next} ATTEMPT REMAINING · RECALIBRATE`);
      else setErrorMsg(`ACCESS DENIED · SIGNAL NOT RECOGNIZED · ${3-next} ATTEMPTS REMAINING`);
      setTimeout(()=>setErrorMsg(""), 3500);
    }
  }

  function handleKey(e) { if (e.key === "Enter") handleSubmit(); }

  const isChallenge = ["challenge","solving","granted"].includes(phase);

  return (
    <div className={`gate-root ${dissolving?"gate-dissolve":""} ${isChallenge?"gate-root--challenge":""}`}>

      {/* Ambient particles */}
      <div className="gate-particles">
        {Array.from({length:28}).map((_,i)=>(
          <div key={i} className="gate-particle" style={{
            left:`${(i*37+11)%100}%`, top:`${(i*53+7)%100}%`,
            animationDelay:`${(i*0.29)%5}s`, animationDuration:`${4+(i%6)}s`
          }}/>
        ))}
      </div>
      <div className="gate-scanlines"/>

      {/* Sound toggle */}
      <button className={`gate-sound-btn ${soundOn?"active":""}`} onClick={()=>setSoundOn(s=>!s)}>
        <div className="gate-sound-dot"/>
        {soundOn?"SOUND ON":"SOUND OFF"}
      </button>

      {/* ── LORE PHASES ── */}
      {!isChallenge && (
        <div className="gate-lore-layout">

          {/* TOP ZONE — Logo + sigil */}
          <div className="gate-top-zone">
            {phase !== "void" && (
              <div className="gate-logo gate-fade-in">
                <GateLogoMark/>
                <div className="gate-logo-text">
                  <span className="gate-wordmark">SPECVLVM</span>
                  <span className="gate-wordmark-sub">· Auditus ·</span>
                </div>
              </div>
            )}
            <div className={`gate-orbital ${phase!=="void"?"gate-orbital--visible":""}`}>
              <GateSigil phase={phase} glitch={glitchActive} chapter={loreChapter}/>
            </div>
          </div>

          {/* BOTTOM ZONE — Text content */}
          <div className="gate-bottom-zone">
            {phase === "void" && <div className="gate-void"/>}
            {phase === "sigil" && (
              <div className="gate-sigil-phase gate-fade-in">
                <div className="gate-boot-lines">
                  <BootLine delay={0}   text="SPECVLVM · REV. III · INITIALIZING"/>
                  <BootLine delay={400} text="ORDO SEMEION · CHARTER §§I–VI · LOADED"/>
                  <BootLine delay={800} text="EXAMINING APPARATUS · STANDBY"/>
                </div>
              </div>
            )}
            {phase === "lore" && (
              <div className={`gate-lore-chapter ${showChapter?"gate-fade-in":"gate-fade-out"}`}>
                {/* Chapter progress dots */}
                <div className="gate-chapter-indicator">
                  {LORE_CHAPTERS.map((_,i)=>(
                    <div key={i} className={`gate-chapter-dot ${i===loreChapter?"gate-chapter-dot--active":i<loreChapter?"gate-chapter-dot--done":""}`}/>
                  ))}
                </div>
                {/* Lore text */}
                <div className="gate-lore-lines">
                  {LORE_CHAPTERS[loreChapter].lines.map((line,i)=>(
                    <LoreLine key={`${loreChapter}-${i}`} {...line}/>
                  ))}
                </div>
                <button className="gate-skip-btn" onClick={()=>setSkipLore(true)}>
                  <span className="gate-mono gate-mono--faint">SKIP TO EXAMINATION →</span>
                </button>
              </div>
            )}
          </div>
        </div>
      )}

      {/* ── CHALLENGE SPLIT ── */}
      {isChallenge && (
        <div className="gate-split gate-fade-in">
          {/* LEFT — Sigil + lore stream */}
          <div className="gate-split-left">
            <div className="gate-split-left-inner">
              <div className="gate-challenge-logo">
                <GateLogoMark/>
                <span className="gate-wordmark" style={{fontSize:"15px"}}>SPECVLVM</span>
                <span className="gate-wordmark-sub" style={{fontSize:"12px"}}>· Auditus ·</span>
              </div>
              <div className="gate-keyhole-wrap">
                <KeyholeSigil state={keyholeState} glitch={glitchActive}/>
              </div>
              <div className="gate-lore-stream-wrap">
                <div className="gate-lore-stream-fade-top"/>
                <div className="gate-lore-stream"><LoreStream/></div>
                <div className="gate-lore-stream-fade-bottom"/>
              </div>
            </div>
            <div className="gate-split-rule"/>
          </div>

          {/* RIGHT — Input + phases */}
          <div className="gate-split-right">
            <div className="gate-split-right-inner">
              {phase === "challenge" && (
                <div className="gate-challenge-v2">
                  <div className="gate-challenge-header">
                    <span className="gate-mono gate-mono--dim">SIGNAL VERIFICATION</span>
                    <span className="gate-mono gate-mono--faint">FIELD INSTRUMENT №01</span>
                  </div>
                  <div className="gate-challenge-lore">
                    <p className="gate-lore-text">Only those who carry the signal may operate the bench.</p>
                    <p className="gate-lore-text gate-lore-text--dim">The Order does not authenticate by name. It authenticates by resonance.</p>
                  </div>
                  <div className="gate-input-block">
                    <div className="gate-input-label">
                      <span className="gate-mono gate-mono--faint">ENTER SIGNAL KEY</span>
                    </div>
                    <div className={`gate-input-wrap ${glitchActive?"gate-input-wrap--error":keyholeState==="active"?"gate-input-wrap--active":""}`}>
                      <span className="gate-input-prefix">§</span>
                      <input ref={inputRef} className="gate-input" type="password"
                        value={inputVal} onChange={handleInputChange} onKeyDown={handleKey}
                        placeholder="· · ·" maxLength={20} autoComplete="off" spellCheck={false}/>
                      <button className="gate-submit-btn" onClick={handleSubmit}>
                        <span className="gate-mono">TRANSMIT →</span>
                      </button>
                    </div>
                    {errorMsg ? (
                      <div className="gate-error gate-fade-in">
                        <span className="gate-mono gate-mono--warn">{errorMsg}</span>
                      </div>
                    ) : (
                      <div className="gate-hint">
                        <span className="gate-mono gate-mono--faint">AWAITING SIGNAL · CHARTER §I</span>
                      </div>
                    )}
                  </div>
                  <div className="gate-challenge-attempts">
                    {[0,1,2].map(i=>(
                      <div key={i} className={`gate-attempt-pip ${i<attempts?"gate-attempt-pip--used":""}`}/>
                    ))}
                    <span className="gate-mono gate-mono--faint" style={{marginLeft:10}}>
                      {3-attempts} ATTEMPT{3-attempts!==1?"S":""} REMAINING
                    </span>
                  </div>
                  <div className="gate-footer-lore">
                    <span className="gate-mono gate-mono--faint">"No magic; only mechanism, made plain."</span>
                    <span className="gate-mono gate-mono--faint">ORDO·SEMEION·MMXXVI</span>
                  </div>
                </div>
              )}
              {phase === "solving" && (
                <div className="gate-solving gate-fade-in">
                  <div className="gate-solving-lines">
                    <SolvingLine delay={0}    text="SIGNAL RECEIVED · VERIFYING RESONANCE"/>
                    <SolvingLine delay={400}  text="CROSS-REFERENCING CHARTER §§I–VI"/>
                    <SolvingLine delay={800}  text="OPERATOR SIGNATURE · MATCHED"/>
                    <SolvingLine delay={1200} text="CALIBRATING EXAMINING APPARATUS"/>
                    <SolvingLine delay={1700} text="DRIFT QUOTIENT BASELINE · 0.00" gold/>
                  </div>
                </div>
              )}
              {phase === "granted" && (
                <div className="gate-granted gate-fade-in">
                  <div className="gate-granted-mark">
                    <span className="gate-mono gate-mono--gold">ACCESS GRANTED · BENCH ONLINE</span>
                  </div>
                  <div className="gate-granted-lore">
                    <p className="gate-lore-text gate-lore-text--gold">The bench is yours.</p>
                    <p className="gate-lore-text gate-lore-text--dim">
                      The findings belong to the operator.<br/>
                      The Charter governs what you do with them.<br/>
                      Nothing is retained unless you save it to your archive.
                    </p>
                  </div>
                  <div className="gate-granted-footer">
                    <span className="gate-mono gate-mono--faint">INITIALIZING BENCH · FIELD INSTRUMENT №01 · REV. III</span>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Bottom bar */}
      <div className="gate-bottom-bar">
        <span className="gate-mono gate-mono--faint">SPECVLVM · REV. III</span>
        <span className="gate-mono gate-mono--faint">NO SPECIMENS STORED OUTSIDE THIS SESSION</span>
        <span className="gate-mono gate-mono--faint">ORDO·SEMEION·MMXXVI</span>
      </div>
    </div>
  );
}

/* ── Sub-components ── */
function BootLine({text,delay}) {
  const [vis,setVis]=React.useState(false);
  React.useEffect(()=>{const t=setTimeout(()=>setVis(true),delay);return()=>clearTimeout(t);},[delay]);
  return(
    <div className={`gate-boot-line ${vis?"gate-boot-line--visible":""}`}>
      <span className="gate-mono gate-mono--dim">{vis?`> ${text}`:""}</span>
      {vis&&<span className="gate-cursor">_</span>}
    </div>
  );
}

function LoreLine({text,delay,mono,serif,gold,dim}) {
  const [vis,setVis]=React.useState(false);
  React.useEffect(()=>{const t=setTimeout(()=>setVis(true),delay);return()=>clearTimeout(t);},[delay]);
  return(
    <div className={["gate-lore-line",vis?"gate-lore-line--visible":"",mono?"gate-mono":"",serif?"gate-lore-serif":"",gold?"gate-lore-line--gold":"",dim?"gate-lore-line--dim":""].filter(Boolean).join(" ")}>
      {text}
    </div>
  );
}

function SolvingLine({text,delay,gold}) {
  const [vis,setVis]=React.useState(false);
  const [done,setDone]=React.useState(false);
  React.useEffect(()=>{
    const t1=setTimeout(()=>setVis(true),delay);
    const t2=setTimeout(()=>setDone(true),delay+350);
    return()=>[t1,t2].forEach(clearTimeout);
  },[delay]);
  return(
    <div className={`gate-sline ${vis?"gate-sline--visible":""} ${gold?"gate-sline--gold":""}`}>
      <span className="gate-sline-cursor">{done?"✓":"›"}</span>
      <span className="gate-mono">{text}</span>
    </div>
  );
}

function GateLogoMark() {
  return(
    <svg width="28" height="28" viewBox="0 0 32 32" fill="none">
      <circle cx="16" cy="16" r="14.5" stroke="var(--accent)" strokeWidth="0.8" opacity="0.5"/>
      <circle cx="16" cy="16" r="9"    stroke="var(--accent)" strokeWidth="0.6" opacity="0.35"/>
      <circle cx="16" cy="16" r="4.5"  stroke="var(--accent)" strokeWidth="0.5" opacity="0.3"/>
      {[0,60,120,180,240,300].map((deg,i)=>{
        const r=9,rad=deg*Math.PI/180;
        return <circle key={i} cx={16+Math.cos(rad)*r} cy={16+Math.sin(rad)*r} r="1.2" fill="var(--accent)" opacity="0.6"/>;
      })}
      <path d="M16 10.5 C18 13 19.5 15 19.5 17 C19.5 19.5 17.9 21.5 16 21.5 C14.1 21.5 12.5 19.5 12.5 17 C12.5 15 14 13 16 10.5Z" fill="var(--ink)" opacity="0.9"/>
      <circle cx="16" cy="16" r="1.5" fill="var(--accent)" opacity="0.5"/>
    </svg>
  );
}

function LoreStream() {
  const containerRef=React.useRef(null);
  const [lines,setLines]=React.useState([]);
  const idx=React.useRef(0);
  const timer=React.useRef(null);
  React.useEffect(()=>{
    function next(){
      if(idx.current>=LORE_STREAM.length){idx.current=0;setLines([]);timer.current=setTimeout(next,1000);return;}
      const line=LORE_STREAM[idx.current];
      setLines(p=>[...p.slice(-28),{...line,id:Date.now()+idx.current}]);
      idx.current++;
      const d=line.dim?500:line.gold?1100:line.serif?1700:750;
      timer.current=setTimeout(next,d);
    }
    timer.current=setTimeout(next,300);
    return()=>clearTimeout(timer.current);
  },[]);
  React.useEffect(()=>{if(containerRef.current)containerRef.current.scrollTop=containerRef.current.scrollHeight;},[lines]);
  return(
    <div ref={containerRef} className="gate-lore-stream-inner">
      {lines.map((line,i)=>{
        const cls=["gate-stream-line",line.mono?"gate-mono":"gate-stream-serif",line.gold?"gate-stream-line--gold":"",line.dim?"gate-stream-line--dim":"",i===lines.length-1?"gate-stream-line--latest":""].filter(Boolean).join(" ");
        return <div key={line.id} className={cls}>{line.text}</div>;
      })}
    </div>
  );
}

function KeyholeSigil({state,glitch}) {
  const isActive=state==="active",isError=state==="error",isUnlock=state==="unlocking",isOpen=state==="open";
  const cc=isError?"var(--warn)":"var(--accent)";
  return(
    <div className={`keyhole-root ${isError?"keyhole--error":""} ${isUnlock?"keyhole--unlocking":""} ${isOpen?"keyhole--open":""}`}>
      <svg className="keyhole-svg" viewBox="0 0 320 400" fill="none">
        <circle cx="160" cy="148" r="136" stroke={cc} strokeWidth="0.6" opacity="0.2" className="kh-ring-outer"/>
        <circle cx="160" cy="148" r="130" stroke={cc} strokeWidth="0.3" strokeDasharray="4 8" opacity="0.12" className="kh-ring-outer-dash"/>
        {Array.from({length:24}).map((_,i)=>{const a=i*15*Math.PI/180,r1=135,r2=i%6===0?124:129;return<line key={i} x1={160+Math.cos(a)*r1} y1={148+Math.sin(a)*r1} x2={160+Math.cos(a)*r2} y2={148+Math.sin(a)*r2} stroke={cc} strokeWidth={i%6===0?"1.2":"0.5"} opacity={i%6===0?"0.45":"0.2"}/>;})}
        <circle cx="160" cy="148" r="96" stroke={cc} strokeWidth="0.7" opacity="0.28" className="kh-ring-mid"/>
        {[0,60,120,180,240,300].map((deg,i)=>{const rad=deg*Math.PI/180,x=160+Math.cos(rad)*96,y=148+Math.sin(rad)*96,nx=160+Math.cos(((i+2)*60)*Math.PI/180)*96,ny=148+Math.sin(((i+2)*60)*Math.PI/180)*96;return<g key={i}><circle cx={x} cy={y} r="4" fill={cc} opacity="0.45" className="kh-node"/><line x1={x} y1={y} x2={nx} y2={ny} stroke={cc} strokeWidth="0.4" opacity="0.15"/></g>;})}
        <circle cx="160" cy="148" r="64" stroke={cc} strokeWidth="0.8" opacity="0.35" className="kh-ring-inner"/>
        {[0,60,120,180,240,300].map((deg,i)=>{const rad=deg*Math.PI/180;return<line key={i} x1="160" y1="148" x2={160+Math.cos(rad)*130} y2={148+Math.sin(rad)*130} stroke={cc} strokeWidth="0.3" opacity="0.08"/>;})}
        <rect x="118" y="64" width="84" height="110" rx="42" stroke={cc} strokeWidth="1.5" fill="var(--bg-sunk)" opacity="0.95" className="kh-plate"/>
        <rect x="122" y="68" width="76" height="102" rx="38" stroke={cc} strokeWidth="0.5" fill="none" opacity="0.2"/>
        <circle cx="160" cy="104" r="22" stroke={cc} strokeWidth="1.5" fill="var(--bg)" className="kh-circle" style={{filter:isActive?"drop-shadow(0 0 8px var(--accent))":"none",transition:"filter 0.3s ease"}}/>
        <circle cx="160" cy="104" r="16" stroke={cc} strokeWidth="0.6" fill="none" opacity="0.3"/>
        <path d="M149 122 L149 155 Q149 162 160 162 Q171 162 171 155 L171 122 Z" stroke={cc} strokeWidth="1.5" fill="var(--bg)" className="kh-shaft"/>
        <rect x="151" y="143" width="18" height="3" rx="1.5" fill={cc} opacity="0.3"/>
        <circle cx="160" cy="104" r="9" fill={cc} opacity={isOpen?"0":isActive?"0.6":"0.35"} className="kh-keyhole-eye" style={{transition:"opacity 0.4s ease"}}/>
        <rect x="158" y="104" width="4" height="10" rx="1" fill="var(--bg)" opacity={isOpen?"0":"0.9"}/>
        {isActive&&<circle cx="160" cy="104" r="24" stroke="var(--accent)" strokeWidth="1" fill="none" opacity="0.15" className="kh-active-ring"/>}
        {isError&&<g opacity="0.7" className="kh-error-cross"><line x1="148" y1="92" x2="172" y2="116" stroke="var(--warn)" strokeWidth="2" strokeLinecap="round"/><line x1="172" y1="92" x2="148" y2="116" stroke="var(--warn)" strokeWidth="2" strokeLinecap="round"/></g>}
        {isUnlock&&<circle cx="160" cy="104" r="24" stroke="var(--accent)" strokeWidth="1.5" fill="none" opacity="0.4" strokeDasharray="10 6" className="kh-unlock-spin"/>}
        {isOpen&&<><circle cx="160" cy="104" r="28" fill="var(--accent)" opacity="0.08" className="kh-open-glow"/><circle cx="160" cy="104" r="9" fill="var(--accent)" opacity="0.4" className="kh-open-core"/></>}
        <circle cx="160" cy="148" r="64" stroke={cc} strokeWidth="2" fill="none"
          strokeDasharray={isActive?"80 322":isOpen?"402 0":"0 402"} strokeDashoffset="-40"
          opacity={isActive||isOpen?"0.35":"0"} style={{transition:"stroke-dasharray 0.6s ease,opacity 0.4s ease"}} className="kh-sector-ring"/>
        <line x1="160" y1="162" x2="160" y2="200" stroke={cc} strokeWidth="0.6" opacity="0.15" strokeDasharray="2 4"/>
        <text x="160" y="230" textAnchor="middle" fontFamily="var(--mono),monospace" fontSize="9" letterSpacing="3" fill={cc} opacity="0.5">
          {isError?"DENIED":isOpen?"OPEN":isUnlock?"UNLOCKING":isActive?"READING":"LOCKED"}
        </text>
        {[{deg:-90,label:"§I"},{deg:-30,label:"§II"},{deg:30,label:"§III"},{deg:90,label:"§IV"},{deg:150,label:"§V"},{deg:210,label:"§VI"}].map(({deg,label},i)=>{
          const rad=deg*Math.PI/180,r=116;
          return<text key={i} x={160+Math.cos(rad)*r} y={148+Math.sin(rad)*r+4} textAnchor="middle" fontFamily="var(--mono),monospace" fontSize="7.5" letterSpacing="1" fill={cc} opacity={isOpen?"0.7":"0.25"}>{label}</text>;
        })}
        {isUnlock&&[0,1,2].map(j=><circle key={j} cx="160" cy="148" r="64" stroke="var(--accent)" strokeWidth="1" fill="none" opacity="0" className={`kh-pulse-ring kh-pulse-ring--${j}`}/>)}
        {isOpen&&<circle cx="160" cy="148" r="96" fill="var(--accent)" opacity="0.05" className="kh-granted-glow"/>}
      </svg>
      <div className="keyhole-motto">
        <span className="gate-mono gate-mono--faint">
          {isOpen?"THE BENCH IS OPEN":isUnlock?"SIGNAL VERIFIED":isError?"SIGNAL REJECTED":"SIGNAL VERIFICATION REQUIRED"}
        </span>
      </div>
    </div>
  );
}

function GateSigil({phase,glitch,chapter}) {
  const active=phase!=="void",granted=phase==="granted",solving=phase==="solving";
  return(
    <svg className={["gate-sigil-svg",glitch?"gate-sigil--glitch":"",granted?"gate-sigil--granted":""].filter(Boolean).join(" ")} viewBox="0 0 500 500" fill="none">
      <circle cx="250" cy="250" r="222" stroke="var(--accent)" strokeWidth="0.5" opacity={active?"0.18":"0"} className="gate-ring-outer" style={{transition:"opacity 1.2s ease"}}/>
      <circle cx="250" cy="250" r="216" stroke="var(--accent)" strokeWidth="0.4" strokeDasharray="3 9" opacity={active?"0.12":"0"} className="gate-ring-outer-dash" style={{transition:"opacity 1.4s ease 0.2s"}}/>
      <circle cx="250" cy="250" r="196" stroke="var(--accent)" strokeWidth="0.6" strokeDasharray={`${chapter*10+20} ${180-chapter*10}`} opacity={active?"0.22":"0"} className="gate-ring-chapter" style={{transition:"opacity 0.8s ease"}}/>
      <circle cx="250" cy="250" r="165" stroke="var(--accent)" strokeWidth="0.7" opacity={active?"0.28":"0"} className="gate-ring-mid" style={{transition:"opacity 1s ease 0.4s"}}/>
      <circle cx="250" cy="250" r="110" stroke="var(--accent)" strokeWidth="0.6" opacity={active?"0.32":"0"} className="gate-ring-inner" style={{transition:"opacity 1s ease 0.6s"}}/>
      {[0,60,120,180,240,300].map((deg,i)=>{const rad=deg*Math.PI/180;return<line key={i} x1="250" y1="250" x2={250+Math.cos(rad)*216} y2={250+Math.sin(rad)*216} stroke="var(--accent)" strokeWidth="0.4" opacity={active?"0.1":"0"} style={{transition:`opacity 1s ease ${0.6+i*0.08}s`}}/>;} )}
      {[0,60,120,180,240,300].map((deg,i)=>{
        const rad=deg*Math.PI/180,x=250+Math.cos(rad)*165,y=250+Math.sin(rad)*165;
        const nx=250+Math.cos(((i+2)*60)*Math.PI/180)*165,ny=250+Math.sin(((i+2)*60)*Math.PI/180)*165;
        const isAct=i===chapter%6;
        return(<g key={i}>
          <circle cx={x} cy={y} r={isAct?6:4} fill="var(--accent)" opacity={active?(isAct?0.9:0.45):0} className={isAct?"gate-node gate-node--active":"gate-node"} style={{transition:`opacity 0.8s ease ${0.8+i*0.08}s`}}/>
          <line x1={x} y1={y} x2={nx} y2={ny} stroke="var(--accent)" strokeWidth="0.5" opacity={active?"0.16":"0"} style={{transition:`opacity 0.8s ease ${1+i*0.08}s`}}/>
        </g>);
      })}
      <g className="gate-arc-lines" opacity={active?"0.13":"0"} style={{transition:"opacity 1.2s ease 1s"}}>
        <line x1="250" y1="28" x2="130" y2="448" stroke="var(--accent)" strokeWidth="0.5"/>
        <line x1="250" y1="28" x2="370" y2="448" stroke="var(--accent)" strokeWidth="0.5"/>
        <line x1="28"  y1="250" x2="472" y2="250" stroke="var(--accent)" strokeWidth="0.5"/>
        <line x1="72"  y1="88"  x2="428" y2="412" stroke="var(--accent)" strokeWidth="0.3"/>
        <line x1="72"  y1="412" x2="428" y2="88"  stroke="var(--accent)" strokeWidth="0.3"/>
      </g>
      {Array.from({length:24}).map((_,i)=>{
        const a=i*15*Math.PI/180,r1=220,r2=i%6===0?208:213;
        return<line key={i} x1={250+Math.cos(a)*r1} y1={250+Math.sin(a)*r1} x2={250+Math.cos(a)*r2} y2={250+Math.sin(a)*r2} stroke="var(--accent)" strokeWidth={i%6===0?"1.2":"0.6"} opacity={active?(i%6===0?"0.5":"0.22"):"0"} style={{transition:`opacity 1s ease ${1.2+i*0.02}s`}}/>;
      })}
      <path d="M250 216 C262 232 276 248 276 262 C276 280 264 292 250 292 C236 292 224 280 224 262 C224 248 238 232 250 216Z" fill={granted?"var(--accent)":"var(--ink)"} opacity={active?(granted?1:0.88):0} className="gate-teardrop" style={{transition:"opacity 1.4s ease 1.4s,fill 0.8s ease",filter:granted?"drop-shadow(0 0 16px var(--accent))":"none"}}/>
      {active&&!granted&&<text x="250" y="268" textAnchor="middle" fontFamily="Georgia,serif" fontSize="16" fill="var(--accent)" opacity="0.5">§{chapter+1}</text>}
      <circle cx="250" cy="250" r="3" fill="var(--accent)" opacity={active?"0.6":"0"} style={{transition:"opacity 1s ease 1.6s"}}/>
      {solving&&[0,1,2].map(i=><circle key={i} cx="250" cy="250" r="110" stroke="var(--accent)" strokeWidth="1" opacity="0" fill="none" className={`gate-pulse-ring gate-pulse-ring--${i}`}/>)}
      {granted&&<circle cx="250" cy="250" r="120" fill="var(--accent)" opacity="0.07" className="gate-granted-glow"/>}
    </svg>
  );
}

/* Expose entry component to global scope (per-file build) */
Object.assign(window, { GateScreen });
